module.exports = __webpack_public_path__ + "7288dd97574b5d797b7d3d7f15fdb0a3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/cos/0C000016RV.png
// module id = 1658
// module chunks = 0